import useToggleText from 'hooks/useToggleText';
import React from 'react';
import { cleanText } from 'utils/cleanText';

export default function PublishedToggleableContent({ item }) {

    const cleanContent = cleanText(item.content);
    const { displayText, isExpanded, toggle, canExpand } = useToggleText(cleanContent, 100);

    return (
        <p>
            {displayText}
            {canExpand && (
                <button type="button"
                    onClick={toggle}
                    className="btn-interactive read-more">
                    {isExpanded ? " Show Less" : " Read More"}
                </button>
            )}
        </p>)
}
